import { Box } from "@mui/material";
import React from "react";
import { allowedToUpdateEntity } from "src/constants/role";
import { dataStateType } from "src/constants/status";
import { useGetPermissionAccessControl } from "src/context/PermissionAccessControl";
import useAuth from "src/hooks/useAuth";
import { appVersionColumns as columns, MODE_RELEASE } from "../../Helper";
import Controls from "src/components/form/controls/Controls";
import { isOpenPopup } from "src/utils/isOpenPopup";

const GetReleaseAppVersionColumns = ({
  handleOpenPopup,
  handleChangeModeRelease,
  status,
}) => {
  const { auth } = useAuth();
  const permissionsAccessControl = useGetPermissionAccessControl();

  const releaseGroupCol = {
    key: "releaseGroup",
    label: "Release On Group",
    align: "center",
    render: (item) => (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          minWidth: "120px",
        }}
      >
        <Controls.Checkbox
          name="isReleaseOnGroup"
          label={""}
          style={{ width: "0px" }}
          value={item.isReleaseOnGroup}
          onChange={() =>
            handleChangeModeRelease(
              item.isReleaseOnGroup,
              MODE_RELEASE.releaseOnGroup,
              item
            )
          }
        />
      </Box>
    ),
  };

  const releaseMassCol = {
    key: "releaseMass",
    label: "Release Mass",
    align: "center",
    render: (item) => (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          minWidth: "120px",
        }}
      >
        <Controls.Checkbox
          name="isReleaseOnGroup"
          label={""}
          style={{ width: "0px" }}
          value={item.isReleaseMass}
          onChange={() =>
            handleChangeModeRelease(
              item.isReleaseMass,
              MODE_RELEASE.releaseMass,
              item
            )
          }
        />
      </Box>
    ),
  };

  const actionCol = {
    key: "actions",
    label: "Actions",
    align: "center",
    render: (item) => (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          minWidth: "120px",
        }}
      >
        {allowedToUpdateEntity(auth?.permissions, permissionsAccessControl) && (
          <button
            className="btn btn-warning"
            onClick={() => {
              handleOpenPopup(isOpenPopup, item);
            }}
          >
            <i className="bx bx-edit"></i>
          </button>
        )}
      </Box>
    ),
  };

  if (status === dataStateType.ACTIVE) {
    return [...columns, releaseGroupCol, releaseMassCol, actionCol];
  }

  return columns;
};

export default GetReleaseAppVersionColumns;
